module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ux-onboarding-Artboard-3@2x.4e570a44.png";